import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import SubunitForm from './SubunitForm';
import { updateSubunit, addSubunit } from '../../services/subunitService';
import { getSubunitIDList } from '../../utilities/subunitFormat';

function SubunitEdit(props) {
  const subunit = props.subunit;
  const subunitType = props.subunitType;

  const initialValues = {
    code: subunit?.code,
    title: subunit?.title,
    description: subunit?.description,
    longDescription: subunit?.longDescription,
    sectionNumber: subunit?.sectionNumber,
    icon: subunit?.icon,
    topics: subunit?.topics,
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode',
  });

  const onSubmit = async (values) => {
    let payload = {
      subunitType,
      ...values,
    };

    await updateSubunit(subunit.code, payload)
      .then((response) => {
        console.log('Successfully Updated! ', response);
        setStatus({ type: 'SUCCESS', message: 'Data updated successfully!' });
      })
      .catch((error) => {
        alert('Posting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({ type: 'ERROR', message: error.response.data.message });
        else setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <Modal
      title={`Edit Subnit ${subunit.code}`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}
    >
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <SubunitForm
          type="Update"
          initialValues={initialValues}
          onSubmit={onSubmit}
          subunitType={subunitType}
          status={status}
          visible={props.isOpen}
        />
      )}
    </Modal>
  );
}

export default SubunitEdit;
